import { render, staticRenderFns } from "./LangSwitch.vue?vue&type=template&id=0981b3bf&scoped=true"
import script from "./LangSwitch.vue?vue&type=script&lang=js"
export * from "./LangSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0981b3bf",
  null
  
)

export default component.exports